import axios from "axios";

// A dedicated axios instance for the Laundry Audit module, pointed directly at
// the real Laundry Audit API (REACT_APP_LA_API_URL) — the same host
// MajesticERP-LaundryAuditAdmin/server itself forwards to
// (config_setting.laundry_audit_api). That Node server added nothing but a
// thin relay (occasionally renaming a path, e.g. audit_facility_filter ->
// get_audit_facility_filter), so per our own convention of calling our real
// backend directly (src/utils/apiCall.js -> REACT_APP_API_URL, and the
// Cleaning Audit module's cleaningAuditClient.js), we skip that hop entirely.
//
// Unlike Cleaning Audit's real API, this one (MajesticERP-LaundryAuditAPI)
// already has CORS configured (plain `cors` middleware, credentials:true) —
// no server-side fix was needed here.
//
// This deliberately does NOT share MyM's own client (src/utils/interceptors/axios.js)
// or its errorInterceptor, which clears localStorage and redirects to /login on
// any 401+ — a Laundry-Audit-only auth hiccup must never log the whole app out.
const laundryAuditClient = axios.create({
  baseURL: process.env.REACT_APP_LA_API_URL,
  headers: {
    "content-type": "application/json",
    accept: "application/json",
  },
});

export default laundryAuditClient;
